(function () {
  function init(root) {
    if (root.__wbBundleInit) return;
    root.__wbBundleInit = true;

    var colors = [];
    try { colors = JSON.parse(root.querySelector('[data-bundle-colors]').textContent); } catch (e) {}

    var tiers = Array.prototype.slice.call(root.querySelectorAll('.wb-bundle__tier'));
    var slotsEl = root.querySelector('[data-bundle-slots]');
    var slotsTitle = root.querySelector('[data-bundle-slots-title]');
    var labelSlot = root.getAttribute('data-label-slot') || 'Sac';
    var errColor = root.getAttribute('data-error-color') || '';
    var errGeneric = root.getAttribute('data-error-generic') || '';
    var addBtn = root.querySelector('[data-bundle-add]');
    var addTotal = root.querySelector('[data-bundle-add-total]');
    var klarnaEl = root.querySelector('[data-bundle-klarna]');
    var klarnaTxt = root.querySelector('[data-bundle-klarna-txt]');
    var klarnaTpl = klarnaEl ? (klarnaEl.getAttribute('data-klarna-tpl') || '') : '';
    var klarnaAmt = klarnaEl ? { 1: klarnaEl.getAttribute('data-klarna-1'), 2: klarnaEl.getAttribute('data-klarna-2'), 3: klarnaEl.getAttribute('data-klarna-3') } : {};
    var note = root.querySelector('[data-bundle-note]');
    var currentVid = root.getAttribute('data-current-variant');

    var fmt = {};
    tiers.forEach(function (t) {
      fmt[t.getAttribute('data-tier')] = t.querySelector('.wb-bundle__tier-price').textContent.trim();
    });

    var activeTier = 1;
    var selections = [];

    function defaultIdx() {
      var i = colors.findIndex(function (c) { return String(c.variantId) === String(currentVid); });
      if (i >= 0) return i;
      return colors.findIndex(function (c) { return c.available; });
    }

    function showNote(msg, state) {
      if (!note) return;
      note.textContent = msg || '';
      note.hidden = !msg;
      if (state) note.setAttribute('data-state', state); else note.removeAttribute('data-state');
    }

    function renderSlots() {
      slotsEl.innerHTML = '';
      if (activeTier === 1) { selections = [currentVid]; return; }
      var di = defaultIdx();
      for (var s = 0; s < activeTier; s++) {
        if (selections[s] == null && colors[di]) selections[s] = colors[di].variantId;
        var slot = document.createElement('div');
        slot.className = 'wb-bundle__slot';
        var lbl = document.createElement('span');
        lbl.className = 'wb-bundle__slot-label';
        lbl.textContent = labelSlot + ' ' + (s + 1);
        var sw = document.createElement('div');
        sw.className = 'wb-bundle__swatches';
        colors.forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'wb-bundle__sw' +
            (String(selections[s]) === String(c.variantId) ? ' is-selected' : '') +
            (c.available ? '' : ' is-unavailable');
          b.title = c.name;
          b.setAttribute('aria-label', c.name);
          if (c.img) {
            var im = document.createElement('img');
            im.src = c.img; im.alt = c.name; im.loading = 'lazy';
            b.appendChild(im);
          }
          if (c.available) {
            (function (slotIdx, variantId) {
              b.addEventListener('click', function () { selections[slotIdx] = variantId; renderSlots(); });
            })(s, c.variantId);
          }
          sw.appendChild(b);
        });
        slot.appendChild(lbl);
        slot.appendChild(sw);
        slotsEl.appendChild(slot);
      }
    }

    function setTier(n) {
      activeTier = n;
      selections = selections.slice(0, n);
      tiers.forEach(function (t) {
        var on = t.getAttribute('data-tier') === String(n);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (addTotal) addTotal.textContent = fmt[n] || '';
      if (klarnaTxt && klarnaTpl && klarnaAmt[n]) klarnaTxt.textContent = klarnaTpl.replace('__AMT__', klarnaAmt[n]);
      if (slotsTitle) slotsTitle.hidden = (n === 1);
      showNote('', '');
      renderSlots();
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () { setTier(parseInt(t.getAttribute('data-tier'), 10)); });
    });

    // Order bump : charms cochables, ajoutés dans le même panier que le sac
    var charmBtns = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-charm]'));
    charmBtns.forEach(function (b) {
      if (b.disabled) return;
      b.addEventListener('click', function () {
        var on = b.classList.toggle('is-selected');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });

    addBtn.addEventListener('click', function () {
      var ids = activeTier === 1 ? [currentVid] : selections.slice(0, activeTier);
      if (ids.length < activeTier || ids.some(function (x) { return !x; })) {
        showNote(errColor, 'error');
        return;
      }
      var counts = {};
      ids.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      charmBtns.forEach(function (b) {
        if (b.classList.contains('is-selected')) {
          var vid = b.getAttribute('data-charm-variant');
          if (vid) counts[vid] = (counts[vid] || 0) + 1;
        }
      });
      var payload = { items: Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; }) };
      addBtn.disabled = true;
      showNote('', '');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
          window.location.href = base + 'cart';
        })
        .catch(function () { addBtn.disabled = false; showNote(errGeneric, 'error'); });
    });

    var defaultTier = parseInt(root.getAttribute('data-default-tier'), 10);
    if (!(defaultTier >= 1 && defaultTier <= 3)) defaultTier = 1;
    setTier(defaultTier);
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-wb-bundle]')).forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
